import React from "react";
import Cta from "../cta/cta";

const FinanceCta = () => {
  return (
    <Cta
      heading="Let’s Build Your Financial Success Together"
      firstCta="/signup"
      firstCtaText="Subscribe Now"
      secondCta="/contact-us"
      secondCtaText="Contact us"
    />
  );
};

export default FinanceCta;
